<app-notification-icon
  [data]="data"
  [count]="count()"
  [loading]="loading"
  [(popoverVisible)]="popoverVisible"
  btnClass="alain-default__nav-item"
  btnIconClass="alain-default__nav-item-icon"
  (select)="select($event)"
  (clear)="clear($event)"
>
  <ng-template #descTpl let-i>
    <div [innerHTML]="i.content"></div>
  </ng-template>

  <ng-template #custInfoUpdateTpl let-i>
    <div>{{ i.data | json }}</div>
    <div *ngIf="i.data.count > 1">
      <strong class="text-primary">{{ i.json.count }}</strong> companies has
      updated their Information!
    </div>
    <div *ngIf="i.data.count === 1">
      <strong class="text-primary">{{ i.json.companyName }}</strong> has updated
      their Information!
    </div>
  </ng-template>
</app-notification-icon>
